import { render } from "./talk-outline.svg?vue&type=template&id=16f5c3a4"
const script = {}

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__